import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type WebsiteEventColorsFragment = {
  __typename?: 'EventDesign';
  linkAndButtonColor?: string | null;
  artFontColor?: string | null;
  artBackgroundColor?: string | null;
  pageBackgroundColor?: string | null;
  pageFontColor?: string | null;
};

export type CreateEventDesignMutationVariables = Types.Exact<{
  payload: Types.CreateEventDesignPayload;
}>;

export type CreateEventDesignMutation = { __typename?: 'Mutation'; createEventDesign: { __typename?: 'EventDesign'; purpose: Types.EventDesignPurpose; id: string } };

export type DesignFavoriteQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  type?: Types.InputMaybe<Types.FavoriteType>;
}>;

export type DesignFavoriteQuery = {
  __typename?: 'Query';
  event?: {
    __typename?: 'Event';
    id: string;
    designFavorite?: Array<{
      __typename?: 'DesignFavorite';
      id: string;
      resource: { __typename?: 'DesignLayout'; id: string } | { __typename?: 'Font'; id: string } | { __typename?: 'Theme'; id: string; themeId: string };
      secondaryResource?:
        | { __typename?: 'DesignLayout'; id: string; layoutType: Types.DesignLayoutType }
        | { __typename?: 'Font'; id: string }
        | { __typename?: 'Theme'; id: string; themeId: string }
        | null;
    }> | null;
  } | null;
};

export type ToggleDesignFavoritesMutationVariables = Types.Exact<{
  payload: Array<Types.ToggleDesignFavoriteInput> | Types.ToggleDesignFavoriteInput;
}>;

export type ToggleDesignFavoritesMutation = { __typename?: 'Mutation'; toggleDesignFavorites?: Array<{ __typename?: 'DesignFavorite'; id: string }> | null };

export type WebsiteApplyWebsiteColorsMutationVariables = Types.Exact<{
  payload: Types.ApplyWebsiteColorsPayload;
}>;

export type WebsiteApplyWebsiteColorsMutation = {
  __typename?: 'Mutation';
  applyWebsiteColors: {
    __typename?: 'EventDesign';
    id: string;
    linkAndButtonColor?: string | null;
    artFontColor?: string | null;
    artBackgroundColor?: string | null;
    pageBackgroundColor?: string | null;
    pageFontColor?: string | null;
  };
};

export type UpdateEventWebsiteStateMutationVariables = Types.Exact<{
  payload: Types.EventSetWebsiteStatePayload;
}>;

export type UpdateEventWebsiteStateMutation = { __typename?: 'Mutation'; eventSetWebsiteState: { __typename?: 'Event'; id: string; websiteState: Types.EventWebsiteState } };

export const WebsiteEventColorsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebsiteEventColors' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesign' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'linkAndButtonColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'artFontColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'artBackgroundColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageBackgroundColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageFontColor' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CreateEventDesignDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateEventDesign' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateEventDesignPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createEventDesign' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateEventDesignMutationFn = Apollo.MutationFunction<CreateEventDesignMutation, CreateEventDesignMutationVariables>;

/**
 * __useCreateEventDesignMutation__
 *
 * To run a mutation, you first call `useCreateEventDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventDesignMutation, { data, loading, error }] = useCreateEventDesignMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateEventDesignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateEventDesignMutation, CreateEventDesignMutationVariables>) {
  return ApolloReactHooks.useMutation<CreateEventDesignMutation, CreateEventDesignMutationVariables>(CreateEventDesignDocument, baseOptions);
}
export type CreateEventDesignMutationHookResult = ReturnType<typeof useCreateEventDesignMutation>;
export type CreateEventDesignMutationResult = Apollo.MutationResult<CreateEventDesignMutation>;
export type CreateEventDesignMutationOptions = Apollo.BaseMutationOptions<CreateEventDesignMutation, CreateEventDesignMutationVariables>;
export const DesignFavoriteDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DesignFavorite' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FavoriteType' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'event' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'designFavorite' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'type' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'type' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resource' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Font' } },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Theme' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DesignLayout' } },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'secondaryResource' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Font' } },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Theme' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DesignLayout' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'layoutType' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useDesignFavoriteQuery__
 *
 * To run a query within a React component, call `useDesignFavoriteQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignFavoriteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignFavoriteQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useDesignFavoriteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DesignFavoriteQuery, DesignFavoriteQueryVariables>) {
  return ApolloReactHooks.useQuery<DesignFavoriteQuery, DesignFavoriteQueryVariables>(DesignFavoriteDocument, baseOptions);
}
export function useDesignFavoriteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DesignFavoriteQuery, DesignFavoriteQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<DesignFavoriteQuery, DesignFavoriteQueryVariables>(DesignFavoriteDocument, baseOptions);
}
export type DesignFavoriteQueryHookResult = ReturnType<typeof useDesignFavoriteQuery>;
export type DesignFavoriteLazyQueryHookResult = ReturnType<typeof useDesignFavoriteLazyQuery>;
export type DesignFavoriteQueryResult = Apollo.QueryResult<DesignFavoriteQuery, DesignFavoriteQueryVariables>;
export const ToggleDesignFavoritesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ToggleDesignFavorites' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ToggleDesignFavoriteInput' } } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'toggleDesignFavorites' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ToggleDesignFavoritesMutationFn = Apollo.MutationFunction<ToggleDesignFavoritesMutation, ToggleDesignFavoritesMutationVariables>;

/**
 * __useToggleDesignFavoritesMutation__
 *
 * To run a mutation, you first call `useToggleDesignFavoritesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleDesignFavoritesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleDesignFavoritesMutation, { data, loading, error }] = useToggleDesignFavoritesMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useToggleDesignFavoritesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleDesignFavoritesMutation, ToggleDesignFavoritesMutationVariables>) {
  return ApolloReactHooks.useMutation<ToggleDesignFavoritesMutation, ToggleDesignFavoritesMutationVariables>(ToggleDesignFavoritesDocument, baseOptions);
}
export type ToggleDesignFavoritesMutationHookResult = ReturnType<typeof useToggleDesignFavoritesMutation>;
export type ToggleDesignFavoritesMutationResult = Apollo.MutationResult<ToggleDesignFavoritesMutation>;
export type ToggleDesignFavoritesMutationOptions = Apollo.BaseMutationOptions<ToggleDesignFavoritesMutation, ToggleDesignFavoritesMutationVariables>;
export const WebsiteApplyWebsiteColorsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'WebsiteApplyWebsiteColors' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplyWebsiteColorsPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyWebsiteColors' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WebsiteEventColors' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebsiteEventColors' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesign' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'linkAndButtonColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'artFontColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'artBackgroundColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageBackgroundColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageFontColor' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type WebsiteApplyWebsiteColorsMutationFn = Apollo.MutationFunction<WebsiteApplyWebsiteColorsMutation, WebsiteApplyWebsiteColorsMutationVariables>;

/**
 * __useWebsiteApplyWebsiteColorsMutation__
 *
 * To run a mutation, you first call `useWebsiteApplyWebsiteColorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebsiteApplyWebsiteColorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [websiteApplyWebsiteColorsMutation, { data, loading, error }] = useWebsiteApplyWebsiteColorsMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useWebsiteApplyWebsiteColorsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<WebsiteApplyWebsiteColorsMutation, WebsiteApplyWebsiteColorsMutationVariables>,
) {
  return ApolloReactHooks.useMutation<WebsiteApplyWebsiteColorsMutation, WebsiteApplyWebsiteColorsMutationVariables>(WebsiteApplyWebsiteColorsDocument, baseOptions);
}
export type WebsiteApplyWebsiteColorsMutationHookResult = ReturnType<typeof useWebsiteApplyWebsiteColorsMutation>;
export type WebsiteApplyWebsiteColorsMutationResult = Apollo.MutationResult<WebsiteApplyWebsiteColorsMutation>;
export type WebsiteApplyWebsiteColorsMutationOptions = Apollo.BaseMutationOptions<WebsiteApplyWebsiteColorsMutation, WebsiteApplyWebsiteColorsMutationVariables>;
export const UpdateEventWebsiteStateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateEventWebsiteState' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'EventSetWebsiteStatePayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventSetWebsiteState' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'websiteState' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateEventWebsiteStateMutationFn = Apollo.MutationFunction<UpdateEventWebsiteStateMutation, UpdateEventWebsiteStateMutationVariables>;

/**
 * __useUpdateEventWebsiteStateMutation__
 *
 * To run a mutation, you first call `useUpdateEventWebsiteStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventWebsiteStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventWebsiteStateMutation, { data, loading, error }] = useUpdateEventWebsiteStateMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateEventWebsiteStateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEventWebsiteStateMutation, UpdateEventWebsiteStateMutationVariables>) {
  return ApolloReactHooks.useMutation<UpdateEventWebsiteStateMutation, UpdateEventWebsiteStateMutationVariables>(UpdateEventWebsiteStateDocument, baseOptions);
}
export type UpdateEventWebsiteStateMutationHookResult = ReturnType<typeof useUpdateEventWebsiteStateMutation>;
export type UpdateEventWebsiteStateMutationResult = Apollo.MutationResult<UpdateEventWebsiteStateMutation>;
export type UpdateEventWebsiteStateMutationOptions = Apollo.BaseMutationOptions<UpdateEventWebsiteStateMutation, UpdateEventWebsiteStateMutationVariables>;
